import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
type CountdownTimerProps = {
  label: string;
  note: string;
  tone?: 'light' | 'dark';
};
const START_SECONDS = 23 * 3600 + 53 * 60 + 5;
export function CountdownTimer({
  label,
  note,
  tone = 'light'
}: CountdownTimerProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(START_SECONDS);
  const isDark = tone === 'dark';
  const units = [{
    value: hours,
    name: 'hs'
  }, {
    value: minutes,
    name: 'min'
  }, {
    value: seconds,
    name: 'seg'
  }];
  return <div className="text-center" data-id="element-41" data-mp="1fdww0bma4go1">
      <p className={`text-sm font-semibold uppercase tracking-[0.18em] ${isDark ? 'text-mint-200' : 'text-mint-700'}`} data-id="element-42" data-mp="1ach7uaot1u1f">
        {label}
      </p>
      <div className="mt-5 flex items-center justify-center gap-3" data-id="element-43" data-mp="15f7dcgmk6s6q">
        {units.map(unit => <div key={unit.name} className={`w-24 rounded-2xl px-3 py-4 sm:w-28 ${isDark ? 'bg-white/10' : 'bg-white shadow-soft'}`} data-id="element-44" data-mp="34pgwsuf2s0ld">
            <span className={`block font-display text-4xl tabular-nums sm:text-5xl ${isDark ? 'text-white' : 'text-ink'}`} data-id="element-45" data-mp="2zpkowk39bp0j">
              {unit.value}
            </span>
            <span className={`mt-1 block text-xs uppercase tracking-[0.16em] ${isDark ? 'text-mint-200' : 'text-ink-muted'}`} data-id="element-46" data-mp="1h0jhup1cqjdw">
              {unit.name}
            </span>
          </div>)}
      </div>
      <p className={`mt-5 text-sm ${isDark ? 'text-mint-100' : 'text-ink-muted'}`} data-id="element-47" data-mp="172df657q197z">
        {note}
      </p>
    </div>;
}